import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import { Icon } from '@iconify/react';

export default function BigOnOffCards({ checked, onChange, yesTitle, yesDesc, noTitle, noDesc }) {
    return (
        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', mb: 3 }}>
            <Box
                onClick={() => onChange(true)}
                sx={{
                    p: 2,
                    borderRadius: '16px',
                    border: '1.5px solid',
                    borderColor: checked ? '#00A76F' : '#EBEBEB',
                    backgroundColor: checked ? '#F0FAF6' : '#fff',
                    cursor: 'pointer',
                    transition: 'all 0.15s',
                    textAlign: 'center',
                    userSelect: 'none',
                    '&:hover': { borderColor: checked ? '#00A76F' : '#ddd' },
                }}
            >
                <Icon icon="mdi:check-circle" width={28} height={28} style={{ color: '#00A76F', marginBottom: 8 }} />
                <Typography sx={{ fontSize: 14, fontWeight: 700, color: '#0D0D0D', mb: '3px' }}>
                    {yesTitle}
                </Typography>
                <Typography sx={{ fontSize: 11.5, color: '#7A7A7A', lineHeight: 1.4 }}>
                    {yesDesc}
                </Typography>
            </Box>
            <Box
                onClick={() => onChange(false)}
                sx={{
                    p: 2,
                    borderRadius: '16px',
                    border: '1.5px solid',
                    borderColor: !checked ? '#FFCECE' : '#EBEBEB',
                    backgroundColor: !checked ? '#FFF5F5' : '#fff',
                    cursor: 'pointer',
                    transition: 'all 0.15s',
                    textAlign: 'center',
                    userSelect: 'none',
                    '&:hover': { borderColor: !checked ? '#FFCECE' : '#ddd' },
                }}
            >
                <Icon icon="mdi:close-circle-outline" width={28} height={28} style={{ color: '#919EAB', marginBottom: 8 }} />
                <Typography sx={{ fontSize: 14, fontWeight: 700, color: '#0D0D0D', mb: '3px' }}>
                    {noTitle}
                </Typography>
                <Typography sx={{ fontSize: 11.5, color: '#7A7A7A', lineHeight: 1.4 }}>
                    {noDesc}
                </Typography>
            </Box>
        </Box>
    );
}

BigOnOffCards.propTypes = {
    checked: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
    yesTitle: PropTypes.string.isRequired,
    yesDesc: PropTypes.string.isRequired,
    noTitle: PropTypes.string.isRequired,
    noDesc: PropTypes.string.isRequired,
};
